// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zCoj","left":"styles_left__2CKtd"};